import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Uploader from './Uploader';
import HomeLogo from './HomeLogo';
import EmailLogoUploader from './EmailLogoUploader';
import FavIconUploader from './FavIconUploader';
import CommonFormComponent from '../../CommonField/CommonFormComponent';

import submit from './submit';
import validate from './validate';


import OgImageUploader from './OgImageUploader/OgImageUploader';
import { getHomePagePreview, getPreviewLabel } from '../../../helpers/HomePageLayout/getHomePagePreview';
import PreviewModal from './PreviewModal/PreviewModal';
import updateSpecificSiteSettings from '../../../actions/siteadmin/SiteSettings/updateSpecificSiteSettings';
import ToolTipSection from '../../Common/ToolTipSection/ToolTipSection';

import cs from '../../../components/commonStyle.css';
import s from './SiteSettingsForm.css';
import messages from '../../../locale/jsonMessages';

class SiteSettingsForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,

  };

  constructor(props) {
    super(props);
    this.state = {
      homePageType: null,
      showModal: false,
      previewLabel: 'homePageLayoutDesc',
      layout: [],
    }
  }

  UNSAFE_componentWillMount() {
    const { homePageType } = this.props;

    if (homePageType) {
      this.setState({ hostTypeState: homePageType });
    }
  }

  componentDidMount() {
    const { homePageType } = this.props;

    if (homePageType) {
      this.setState({ hostTypeState: homePageType });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { homePageType } = nextProps;

    if (homePageType) {
      this.setState({ hostTypeState: homePageType });
    }
  }

  openPreviewModal = ({ formatMessage, homePageType }) => {
    const layout = getHomePagePreview({ homePageType })
    const previewLabel = getPreviewLabel({ formatMessage, homePageType });
    this.setState({ showModal: true, layout, previewLabel });
  }

  closePreviewModal = () => {
    this.setState({ showModal: false, layout: [] });
  }

  handleChange = async (e, fieldName) => {
    const { updateSpecificSiteSettings } = this.props;
    await updateSpecificSiteSettings(fieldName, e.target.value);
  }


  render() {
    const { error, handleSubmit, submitting, dispatch, initialValues, appAvailableStatus, appForceUpdate, ogImage } = this.props;
    const { formatMessage } = this.props.intl;
    const { showModal, layout, previewLabel } = this.state;
    const { homePageType, isPromoCodeEnabled } = this.props;

    return (
      <div>
        <PreviewModal
          show={showModal}
          closePreviewModal={this.closePreviewModal}
          openPreviewModal={this.openPreviewModal}
          layout={layout}
          previewLabel={previewLabel}
        />
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.siteSettings} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{error}</strong>}
          <div className="oneColumnGrid">
            <div className='twoColumnGrid'>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)} ><FormattedMessage  {...messages.logoLabel} /></label>
                <Uploader />
              </div>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)} ><FormattedMessage  {...messages.homeLogoLabel} /></label>
                <HomeLogo />
              </div>
            </div>

            <div className='threeColumnFlex'>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)} ><FormattedMessage  {...messages.emailLogoLabel} /></label>
                <EmailLogoUploader />
              </div>
              <div className='siteAdminDropZoneWrapper'>
                <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween, cs.flexWrap, cs.spaceBottom3)}>
                  <label className={cx('commonLabelText', cs.spaceBottom0)} ><FormattedMessage  {...messages.favIconLogoLabel} /></label>
                  <p className={s.favIconText}><FormattedMessage  {...messages.pngOnlyLabel} /></p>
                </div>
                <FavIconUploader />
              </div>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)} >
                  <FormattedMessage  {...messages.ogImageLabel} />
                  <ToolTipSection label={formatMessage(messages.ogToolTip)} />
                </label>
                <OgImageUploader image={ogImage} />
              </div>
            </div>


            <div className='twoColumnGrid'>
              <Field
                name="siteName"
                type="text"
                component={CommonFormComponent}
                labelText={formatMessage(messages.siteName)}
                placeholder={formatMessage(messages.siteName)}
                inputClass='commonInputField'
                isRequiredInput
              />

              <Field name="siteTitle"
                type="text"
                component={CommonFormComponent}
                placeholder={formatMessage(messages.siteTitle)}
                labelText={formatMessage(messages.siteTitle)}
                inputClass='commonInputField'
                isRequiredInput
              />

              <Field
                name="metaKeyword"
                type="text"
                componentClass={"textarea"}
                component={CommonFormComponent}
                inputClass='commonTextAreaField'
                labelText={formatMessage(messages.metaKeywordLabel)}
                placeholder={formatMessage(messages.metaKeywordLabel)} />

              <Field
                name="metaDescription"
                type="text"
                componentClass={"textarea"}
                component={CommonFormComponent}
                labelText={formatMessage(messages.metaKeywordLabelDesc)}
                inputClass='commonTextAreaField'
                placeholder={formatMessage(messages.metaKeywordLabelDesc)} />

              <Field
                name="facebookLink"
                type="text"
                component={CommonFormComponent}
                labelText={formatMessage(messages.facebookURL)}
                placeholder={formatMessage(messages.facebookURL)}
                inputClass='commonInputField' />

              <Field
                name="twitterLink"
                type="text"
                component={CommonFormComponent}
                labelText={formatMessage(messages.twitterURL)}
                placeholder={formatMessage(messages.twitterURL)}
                inputClass='commonInputField' />

              <Field
                name="instagramLink"
                type="text"
                component={CommonFormComponent}
                labelText={formatMessage(messages.instagramURL)}
                placeholder={formatMessage(messages.instagramURL)}
                inputClass='commonInputField' />


              <div>
                <ControlLabel className={cx('commonLabelText', cs.displayFlex, cs.alignCenter, cs.spaceBetween, s.marginBottom9, cs.flexWrap)}>
                  <FormattedMessage  {...messages.homePageLayout} />
                  <span onClick={() => this.openPreviewModal({ formatMessage, homePageType })}
                    className={cx(cs.curserPointer, cs.reviewTitleLink, s.previewText)}>
                    {formatMessage(messages.preview)}
                  </span>
                </ControlLabel>
                <Field name="homePageType" type="text" inputClass='commonSelectField'
                  component={CommonFormComponent} onChange={(e) => this.handleChange(e, 'homePageType')}>
                  <option value={1}>{formatMessage(messages.homePageLayoutDesc)}</option>
                  <option value={2}>{formatMessage(messages.homePageLayoutDesc1)}</option>
                  <option value={3}>{formatMessage(messages.homePageLayoutDesc2)}</option>
                  <option value={4}>{formatMessage(messages.homePageLayoutDesc3)}</option>
                </Field>
              </div>

              <Field
                name="phoneNumberStatus"
                type="text"
                inputClass='commonSelectField'
                component={CommonFormComponent}
                labelText={formatMessage(messages.phoneNumberFormat)}
                placeholder={formatMessage(messages.phoneNumberFormat)}
                onChange={(e) => this.handleChange(e, 'phoneNumberStatus')}
              >
                <option value={1}>{formatMessage(messages.twilioSMS)}</option>
                <option value={3}>{formatMessage(messages.normalPhoneNumber)}</option>
              </Field>

              <Field
                name="securityDepositPreference"
                type="text"
                inputClass='commonSelectField'
                component={CommonFormComponent}
                placeholder={formatMessage(messages.securityDepositAvailability)}
                labelText={formatMessage(messages.securityDepositAvailability)}
                toolTipText={formatMessage(messages.securityDepositAvailabilityTooltip)}
                onChange={(e) => this.handleChange(e, 'securityDepositPreference')}
              >
                <option value={1}>{formatMessage(messages.yesLabel)}</option>
                <option value={2}>{formatMessage(messages.noLabel)}</option>
              </Field>

              <Field
                name="appAvailableStatus"
                type='text'
                inputClass='commonSelectField'
                component={CommonFormComponent}
                labelText={formatMessage(messages.appAvailable)}
                placeholder={formatMessage(messages.appAvailable)}
              >
                <option value={1}>{formatMessage(messages.enableLabel)}</option>
                <option value={0}>{formatMessage(messages.disableLabel)}</option>
              </Field>

              {
                appAvailableStatus == 1 &&
                <>
                  <Field
                    name="playStoreUrl"
                    type="text"
                    component={CommonFormComponent}
                    placeholder={formatMessage(messages.playStoreUrl)}
                    labelText={formatMessage(messages.playStoreUrl)}
                    inputClass='commonInputField' />

                  <Field name="appStoreUrl"
                    type="text"
                    component={CommonFormComponent}
                    labelText={formatMessage(messages.appStoreUrl)}
                    placeholder={formatMessage(messages.appStoreUrl)}
                    inputClass='commonInputField' />
                </>
              }

              {appAvailableStatus == 1 &&
                <>
                  <Field
                    name="appForceUpdate"
                    type='text'
                    inputClass='commonSelectField'
                    component={CommonFormComponent}
                    placeholder={formatMessage(messages.manageForceUpdate)}
                    labelText={formatMessage(messages.manageForceUpdate)}
                  >
                    <option value="true">{formatMessage(messages.enableLabel)}</option>
                    <option value="false">{formatMessage(messages.disableLabel)}</option>
                  </Field>

                  {
                    String(appForceUpdate) === 'true' &&
                    <>
                      <Field
                        name="androidVersion"
                        type="text"
                        isAddon={true}
                        suffixLabel={"V"}
                        component={CommonFormComponent}
                        labelText={formatMessage(messages.androidLabel)}
                        placeholder={formatMessage(messages.androidVersion)}
                        isRequiredInput
                      />
                      <Field
                        name="iosVersion"
                        type="text"
                        isAddon={true}
                        suffixLabel={"V"}
                        component={CommonFormComponent}
                        labelText={formatMessage(messages.iosLabel)}
                        placeholder={formatMessage(messages.iosVersion)}
                        isRequiredInput
                      />
                    </>
                  }
                </>}

              <Field name="email"
                type="text"
                component={CommonFormComponent}
                labelText={formatMessage(messages.emailIdLabel)}
                placeholder={formatMessage(messages.emailIdLabel)}
                inputClass='commonInputField'
                isRequiredInput
              />

              <Field name="contactRecipientEmail"
                type="text"
                component={CommonFormComponent}
                labelText={formatMessage(messages.contactRecipientEmailLabel)}
                toolTipText={formatMessage(messages.contactRecipientEmailToolTip)}
                placeholder={formatMessage(messages.contactRecipientEmailLabel)}
                inputClass='commonInputField'
                isRequiredInput
              />

              <Field
                name="phoneNumber"
                type="text"
                component={CommonFormComponent}
                labelText={formatMessage(messages.mobileNumberLabel)}
                placeholder={formatMessage(messages.mobileNumberLabel)}
                inputClass='commonInputField'
                isRequiredInput
              />

              <Field
                name="address"
                component={CommonFormComponent}
                labelText={formatMessage(messages.address)}
                placeholder={formatMessage(messages.address)}
                inputClass='commonTextAreaField'
                componentClass={"textarea"}
                isRequiredInput
              />
            </div>
          </div>
          <div className={cx('singleBtnFlexEnd', cs.spaceTop4)}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting} ><FormattedMessage  {...messages.save} /></Button>
          </div>
        </form>
      </div>
    );
  }

}


SiteSettingsForm = reduxForm({
  form: 'SiteSettingsForm', // a unique name for this form
  validate
})(SiteSettingsForm);

const selector = formValueSelector('SiteSettingsForm');

const mapState = (state) => ({
  homePageType: selector(state, 'homePageType'),
  appAvailableStatus: selector(state, 'appAvailableStatus'),
  appForceUpdate: selector(state, 'appForceUpdate'),
  ogImage: selector(state, 'ogImage'),
  isPromoCodeEnabled: selector(state, 'isPromoCodeEnabled'),
});

const mapDispatch = {
  updateSpecificSiteSettings
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(SiteSettingsForm)));